import UiLib from '@ai/ui-components'
import { defineComponent, h } from 'vue'
import type { Component } from 'vue'
import type { PropsOf } from '@/types/typeUtils'
import { ACTION_BUTTON_ICONS } from './actionButtonIconsConfig'
import { LIST_ACTION_ICONS as LIST_ACTION_ICONS_CONFIG } from './listActionIconsConfig'

const { UiIcon } = UiLib
type UiIconProps = PropsOf<typeof UiIcon>

interface CreateListActionIconOptions {
  color?: UiIconProps['color']
}

const createListActionIcon = (
  name: UiIconProps['name'],
  { color = '!text-primary' }: CreateListActionIconOptions = {},
): Component =>
  defineComponent({
    name: `ListActionIcon${name.replace(/[^a-zA-Z0-9]/g, '')}`,
    inheritAttrs: false,
    setup() {
      return () =>
        h(UiIcon, {
          name,
          variant: 'solid',
          color,
          clickable: false,
        })
    },
  })

type ListActionIconKey = keyof typeof LIST_ACTION_ICONS_CONFIG

/**
 * Public icon-component registry used by `OListActions` consumers.
 * Built from `LIST_ACTION_ICONS` bindings config and `ACTION_BUTTON_ICONS`
 * canonical icon names to keep direct-action and dropdown icons aligned.
 */
export const LIST_ACTION_ICONS = (
  Object.keys(LIST_ACTION_ICONS_CONFIG) as ListActionIconKey[]
).reduce(
  (acc, key) => {
    const iconConfig = LIST_ACTION_ICONS_CONFIG[key]
    const color = 'color' in iconConfig ? iconConfig.color : undefined
    acc[key] = createListActionIcon(ACTION_BUTTON_ICONS[iconConfig.icon], { color })
    return acc
  },
  {} as Record<ListActionIconKey, Component>,
)
